import { useEffect, useState, useMemo } from "react";
import './Reviews.scss'
import star from '../Components/images/star.svg'
import greyStar from '../Components/images/star-grey.svg'
import whiteStar from '../Components/images/star-white.svg'
import leftArrowWhite from '../Components/images/assets/left-arrow-white.svg'
import rightArrowWhite from '../Components/images/assets/right-arrow-white.svg'
import axios from "axios";
import { useNavigate } from "react-router-dom";

import { API_BASE_URL } from '../config';
import { ensureMediaUrl, reviewImageUrls } from '../utils/mediaUrl';
const BASE_URL = API_BASE_URL;

export function Reviews({ product_id }) {

    const navigate = useNavigate();
    const [ratingMeta, setRatingMeta] = useState({})
    const [modalImages, setModalImages] = useState([])
    const [imageModalOpen, setImageModalOpen] = useState(false);
    const [modalImagesList, setModalImagesList] = useState([]);
    const [modalCurrentIndex, setModalCurrentIndex] = useState(0);
    const [mainModelImageStored, setMainModelImageStored] = useState({ url: '', reviewIndex: null, imageIndex: null, reviewLock: false })
    const [mainModelImage, setMainModelImage] = useState({ url: '', imageIndex: null, i_order: null, prev_i_order: null, next_i_order: null, imageNewPosPrev: null, imageNewPosNext: null, reviewLock: false })
    const [modelOpen, setModelOpen] = useState(false)
    const [storedModelOpen, setStoredModelOpen] = useState(false)
    const [page, setPage] = useState(1)

    useEffect(() => {
        if (!product_id) return;
        setRatingMeta({});
        setModalImages([]);
        fetchProductSpecifications()
        fetchModalImages()
        // Refetch when navigating between PDPs (same route, different :product_id).
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [product_id])

    async function fetchProductSpecifications() {
        try {
            const token = localStorage.getItem("token");
            const config = token ? { headers: { Authorization: `Bearer ${token}` } } : {};

            const response = await axios.post(
                `${BASE_URL}/products/ratings-meta/${product_id}`,
                {
                    page: page,
                    size: 10
                },
                config
            );

            let data = response.data;
            if (Array.isArray(data)) {
                data = null;
            }
            console.log('response data - ', data);

            console.log('product ratings - ', data);
            setMainModelImageStored({ url: reviewImageUrls(data?.reviews_data?.[0]?.images)[0] || "", reviewIndex: mainModelImage.reviewIndex, imageIndex: mainModelImage.imageIndex, reviewLock: mainModelImage.reviewLock })

            setRatingMeta(data && typeof data === 'object' ? { ...data } : {})
            setMainModelImage({ url: reviewImageUrls(data?.reviews_data?.[0]?.images)[0] || "", imageIndex: mainModelImage.imageIndex, i_order: data?.reviews_data?.[0]?.i_order, prev_i_order: mainModelImage.prev_i_order, next_i_order: mainModelImage.next_i_order, imageNewPosPrev: mainModelImage.imageNewPosPrev, imageNewPosNext: mainModelImage.imageNewPosNext, reviewLock: mainModelImage.reviewLock })
        }
        catch (error) {
            console.error("Failed to fetch products:", error);
        }
    }

    async function fetchModalImages() {
        try {
            const token = localStorage.getItem("token");
            const config = token ? { headers: { Authorization: `Bearer ${token}` } } : {};

            const response = await axios.post(
                `${BASE_URL}/products/modal-images/${product_id}`,
                { page: 1, size: 20 },
                config
            );

            const data = response.data;
            setModalImages(Array.isArray(data) ? data : []);
        }
        catch (error) {
            console.error("Failed to fetch products:", error);
        }
    }

    const allPhotosFlat = useMemo(() => {
        const fromModal = (modalImages || []).flatMap((r) => reviewImageUrls(r?.images));
        if (fromModal.length) return fromModal;
        return (ratingMeta?.reviews_data || []).flatMap((r) => reviewImageUrls(r?.images));
    }, [modalImages, ratingMeta]);
    const totalPhotos = allPhotosFlat.length;

    const openImageModal = (imagesList, index) => {
        setModalImagesList(imagesList);
        setModalCurrentIndex(index);
        setImageModalOpen(true);
    };
    const closeImageModal = () => setImageModalOpen(false);
    const modalPrev = () => setModalCurrentIndex((i) => Math.max(0, i - 1));
    const modalNext = () => setModalCurrentIndex((i) => Math.min(modalImagesList.length - 1, i + 1));
    const modalCurrentUrl = modalImagesList[modalCurrentIndex] || null;
    const canModalPrev = modalCurrentIndex > 0;
    const canModalNext = modalCurrentIndex < modalImagesList.length - 1;

    useEffect(() => {
        if (!imageModalOpen) return;
        const onKey = (e) => {
            if (e.key === 'Escape') closeImageModal();
            if (e.key === 'ArrowLeft' && canModalPrev) modalPrev();
            if (e.key === 'ArrowRight' && canModalNext) modalNext();
        };
        window.addEventListener('keydown', onKey);
        document.body.style.overflow = 'hidden';
        return () => {
            window.removeEventListener('keydown', onKey);
            document.body.style.overflow = '';
        };
    }, [imageModalOpen, canModalPrev, canModalNext]);

    async function setReviewImages(imagePos, i_order) {
        // console.log('main model image - ', ratingMeta?.reviews_data?.[reviewPos]?.images?.[imagePos]);
        // console.log('setReviewImages  ', ' reviewPos - ', reviewPos, ' imagePos - ', imagePos);

        // setMainModelImage({ url: ratingMeta?.reviews_data?.[reviewPos]?.images?.[imagePos] || "", imageIndex: imagePos, reviewLock: reviewLock })        
        setStoredModelOpen(false)
        setModelOpen(true)
        // setLoading(true);
        const token = localStorage.getItem("token");
        const config = {
            headers: { Authorization: `Bearer ${token}` }
        };

        const response = await axios.post(
            `/products/reviews-images/${product_id}/${i_order}`,
            {
                page: page,
                size: 10
            },
            config
        );

        let data = response.data;
        console.log('full ratings images - ', data);

        // 1 means previous not found 2 means center found and 3 means next not found
        let imagePosFoundOn = data?.length === 3 ? 2 : data?.[0]?.i_order === i_order ? 1 : 3;
        let initial = 0

        if (imagePosFoundOn === 1) {
            // data = data.reverse()
            if (imagePos <= 0) {
                initial = 1
            }
        }

        if (imagePosFoundOn === 1 && imagePos === 0) {
            // disable prev
            console.log('disable prev');
        }
        else if (imagePosFoundOn === 3 && imagePos === data?.[Math.floor(data.length) - 1]?.images?.length - 1) {
            //  disable next
            console.log('disable next');
        }

        let manageReviewContainer = 0;

        if (imagePosFoundOn === 3) {
            manageReviewContainer = 1
        }

        let imageNewPosPrev = imagePos
        let imageNewPosNext = imagePos
        let prev_new_i_order = i_order
        let next_new_i_order = i_order


        let images_array = []
        console.log('imagePos - ', imagePos, ' - ', i_order);
        if (imagePosFoundOn === 1 && imagePos === 0) {
            console.log('inintial image prev');
            // imageNewPosPrev = -1
            // prev_new_i_order = -1
        }
        else {
            if (data?.[Math.floor(data.length / 2)]?.images?.[imagePos - 1]) {
                console.log('30-11 pass 1 - ', data[Math.floor(data.length / 2)]?.images?.[imagePos - 1]);
                images_array.push(data[Math.floor(data.length / 2)]?.images?.[imagePos - 1])
                imageNewPosPrev = imagePos - 1
            }
            else if (data?.[Math.floor(data.length / 2) - 1]?.images?.[data?.[Math.floor(data.length / 2) - 1]?.images.length - 1]) {
                console.log('30-11 pass 2 - ', data[Math.floor(data.length / 2) - 1]?.images?.[data?.[Math.floor(data.length / 2) - 1]?.images.length - 1])
                images_array.push(data[Math.floor(data.length / 2) - 1]?.images?.[data?.[Math.floor(data.length / 2) - 1]?.images.length - 1])
                imageNewPosPrev = data[Math.floor(data.length / 2) - 1]?.images?.length - 1
                console.log('prev 2 i_order - ', data?.[Math.floor(data.length / 2) - 1]?.["i_order"]);

                prev_new_i_order = data?.[Math.floor(data.length / 2) - 1]?.["i_order"]
            }
        }

        if (imagePosFoundOn === 1) {
            images_array.push(data[Math.floor(data.length / 2) - 1]?.images?.[imagePos])
        }
        else {
            images_array.push(data[Math.floor(data.length / 2)]?.images?.[imagePos])
        }
        if (imagePosFoundOn === 1) {
            console.log('in 1');

            const reversed_data = structuredClone(data)
            if (data[Math.floor(reversed_data.length / 2)]?.images?.[imagePos + 1]) {
                console.log('30-11 pass 3 - ', reversed_data[Math.floor(reversed_data.length / 2) - 1]?.images?.[imagePos + 1]);
                images_array.push(reversed_data[Math.floor(reversed_data.length / 2) - 1]?.images?.[imagePos + 1])
                imageNewPosNext = imagePos + 1
            }
            else if (reversed_data?.[Math.floor(reversed_data.length / 2)]?.images?.[0]) {
                console.log('30-11 pass 4 - ', reversed_data[Math.floor(reversed_data.length / 2)]?.images?.[imagePos + 1])
                images_array.push(reversed_data[Math.floor(reversed_data.length / 2)]?.images?.[0])
                imageNewPosNext = 0
                next_new_i_order = reversed_data?.[Math.floor(reversed_data.length / 2)]?.["i_order"]
            }
        }
        else {
            if (data[Math.floor(data.length / 2)]?.images?.[imagePos + 1]) {
                console.log('30-11 pass 3 - ', data[Math.floor(data.length / 2)]?.images?.[imagePos + 1]);
                images_array.push(data[Math.floor(data.length / 2)]?.images?.[imagePos + 1])
                imageNewPosNext = imagePos + 1
            }
            else if (data?.[Math.floor(data.length / 2) + 1]?.images?.[0]) {
                console.log('30-11 pass 4 - ', data[Math.floor(data.length / 2)]?.images?.[imagePos + 1])
                images_array.push(data[Math.floor(data.length / 2) + 1]?.images?.[0])
                imageNewPosNext = 0
                next_new_i_order = data?.[Math.floor(data.length / 2) + 1]?.["i_order"]
            }
        }

        // if (imagePosFoundOn === 2 || imagePosFoundOn === 3) {
        setMainModelImage({ url: images_array[Math.floor(data.length / 2) - initial] || "", imageIndex: imagePos, i_order: i_order, prev_i_order: prev_new_i_order, next_i_order: next_new_i_order, imageNewPosPrev: imageNewPosPrev, imageNewPosNext: imageNewPosNext, reviewLock: mainModelImage?.reviewLock })
        // }
        // else if (imagePosFoundOn === 3) {
        // setMainModelImage({ url: images_array[Math.floor(data.length / 2)] || "", reviewIndex: reviewPos, imageIndex: imagePos, i_order: i_order, reviewLock: mainModelImage?.reviewLock })
        // }

        console.log('images_array - ', images_array);
    }

    // function openImage(reviewPos, imagePos, reviewLock = false) {
    //     let prev = mainModelImage
    //     console.log('main model image - ', ratingMeta?.reviews_data?.[reviewPos]?.images?.[imagePos]);

    //     setMainModelImage({ url: ratingMeta?.reviews_data?.[reviewPos]?.images?.[imagePos] || "", reviewIndex: reviewPos, imageIndex: imagePos, reviewLock: reviewLock })

    //     setModelOpen(true)
    // }

    async function openImage(reviewPos, imagePos, reviewLock = false, i_order) {
        try {
            setModelOpen(true)
            await setReviewImages(imagePos, i_order)
        }
        catch (error) {
            console.error("Failed to fetch products:", error);
        }

    }



    function prev() {
        console.log('in prev');

        let prev = mainModelImage
        let imageIndex = mainModelImage?.imageNewPosPrev
        let isReviewLock = mainModelImage?.reviewLock
        let prev_i_order = mainModelImage?.prev_i_order

        // ratingMeta?.reviews_data?.[reviewIndex]

        setReviewImages(imageIndex, prev_i_order)

        // if (reviewIndex != null && imageIndex != null) {
        //     if (ratingMeta?.reviews_data?.[reviewIndex]?.images?.[imageIndex - 1]) {
        //         setMainModelImage({ url: ratingMeta?.reviews_data?.[reviewIndex]?.images?.[imageIndex - 1] || "", reviewIndex: reviewIndex, imageIndex: imageIndex - 1, reviewLock: mainModelImage.reviewLock })
        //     }
        //     else if (isReviewLock === false && ratingMeta?.reviews_data?.[reviewIndex - 1] && ratingMeta?.reviews_data?.[reviewIndex - 1]?.images?.length > 0) {
        //         setMainModelImage({ url: ratingMeta?.reviews_data?.[reviewIndex - 1]?.images?.[ratingMeta?.reviews_data?.[reviewIndex - 1]?.images?.length - 1] || "", reviewIndex: reviewIndex - 1, imageIndex: ratingMeta?.reviews_data?.[reviewIndex - 1]?.images?.length - 1, reviewLock: mainModelImage.reviewLock })
        //     }
        //     else {
        //         return
        //     }
        // }
    }

    function next() {
        console.log('in next');

        let prev = mainModelImage
        let imageIndex = mainModelImage?.imageNewPosNext
        let isReviewLock = mainModelImage?.reviewLock
        let next_i_order = mainModelImage?.next_i_order

        setReviewImages(imageIndex, next_i_order)


        // if (reviewIndex != null && imageIndex != null) {
        //     if (ratingMeta?.reviews_data?.[reviewIndex]?.images?.[imageIndex + 1]) {
        //         setMainModelImage({ url: ratingMeta?.reviews_data?.[reviewIndex]?.images?.[imageIndex + 1] || "", reviewIndex: reviewIndex, imageIndex: imageIndex + 1, reviewLock: mainModelImage.reviewLock })
        //     }
        //     else if (isReviewLock === false && ratingMeta?.reviews_data?.[reviewIndex + 1] && ratingMeta?.reviews_data?.[reviewIndex + 1]?.images?.length > 0) {
        //         setMainModelImage({ url: ratingMeta?.reviews_data?.[reviewIndex + 1]?.images?.[0] || "", reviewIndex: reviewIndex + 1, imageIndex: 0, reviewLock: mainModelImage.reviewLock })
        //     }
        //     else {
        //         return
        //     }
        // }
    }

    function prevStored() {
        console.log('in prev');

        let prev = mainModelImageStored
        let reviewIndex = mainModelImageStored?.reviewIndex
        let imageIndex = mainModelImageStored?.imageIndex
        let isReviewLock = mainModelImageStored?.reviewLock

        console.log('reviewIndex - ', reviewIndex, ' imageIndex - ', imageIndex);

        if (reviewIndex != null && imageIndex != null) {
            if (ratingMeta?.reviews_data?.[reviewIndex]?.images?.[imageIndex - 1]) {
                setMainModelImageStored({ url: ratingMeta?.reviews_data?.[reviewIndex]?.images?.[imageIndex - 1] || "", reviewIndex: reviewIndex, imageIndex: imageIndex - 1, reviewLock: mainModelImageStored.reviewLock })
            }
            // else if (isReviewLock === false && ratingMeta?.reviews_data?.[reviewIndex - 1] && ratingMeta?.reviews_data?.[reviewIndex - 1]?.images?.length > 0) {
            //     setMainModelImageStored({ url: ratingMeta?.reviews_data?.[reviewIndex - 1]?.images?.[ratingMeta?.reviews_data?.[reviewIndex - 1]?.images?.length - 1] || "", reviewIndex: reviewIndex - 1, imageIndex: ratingMeta?.reviews_data?.[reviewIndex - 1]?.images?.length - 1, reviewLock: mainModelImageStored.reviewLock })
            // }
            else {
                return
            }
        }
    }

    function nextStored() {
        console.log('in next');

        let prev = mainModelImageStored
        let reviewIndex = mainModelImageStored?.reviewIndex
        let imageIndex = mainModelImageStored?.imageIndex
        let isReviewLock = mainModelImageStored?.reviewLock

        console.log('reviewIndex - ', reviewIndex, ' imageIndex - ', imageIndex);

        if (reviewIndex != null && imageIndex != null) {
            if (ratingMeta?.reviews_data?.[reviewIndex]?.images?.[imageIndex + 1]) {
                setMainModelImageStored({ url: ratingMeta?.reviews_data?.[reviewIndex]?.images?.[imageIndex + 1] || "", reviewIndex: reviewIndex, imageIndex: imageIndex + 1, reviewLock: mainModelImageStored.reviewLock })
            }
            // else if (isReviewLock === false && ratingMeta?.reviews_data?.[reviewIndex + 1] && ratingMeta?.reviews_data?.[reviewIndex + 1]?.images?.length > 0) {
            //     setMainModelImageStored({ url: ratingMeta?.reviews_data?.[reviewIndex + 1]?.images?.[0] || "", reviewIndex: reviewIndex + 1, imageIndex: 0, reviewLock: mainModelImageStored.reviewLock })
            // }
            else {
                return
            }
        }
    }

    function openImageStoredProcessing(reviewPos, imagePos, reviewLock = false) {
        let prev = mainModelImageStored
        console.log('main model image - ', ratingMeta?.reviews_data?.[reviewPos]?.images?.[imagePos]);

        setMainModelImageStored({ url: ratingMeta?.reviews_data?.[reviewPos]?.images?.[imagePos] || "", reviewIndex: reviewPos, imageIndex: imagePos, reviewLock: reviewLock })

    }

    function openImageStored(reviewPos, imagePos, reviewLock = false) {
        setModelOpen(false)
        setStoredModelOpen(true)
        openImageStoredProcessing(reviewPos, imagePos, reviewLock = false)
    }

    console.log('mainModelImage - ', mainModelImage);

    const totalRatingsCount = Number(ratingMeta?.total_ratings_count) || 0;
    const reviewCount = ratingMeta?.reviews_data?.length || 0;
    const ratingsLoaded = Object.keys(ratingMeta || {}).length > 0;
    const hasNoReviews = ratingsLoaded && totalRatingsCount === 0 && reviewCount === 0 && totalPhotos === 0;

    if (hasNoReviews) {
        return (
            <div className="reviews-ratings-container">
                <div className="reviews-unavailable" role="status">
                    <div className="reviews-unavailable__heading">Ratings & Reviews</div>
                    <p className="reviews-unavailable__title">Reviews are not available</p>
                    <p className="reviews-unavailable__text">
                        This product doesn’t have any customer reviews yet.
                    </p>
                </div>
            </div>
        );
    }

    return (
        <div className="reviews-ratings-container">
            <div className="detailedRatingContainer design-4">
                <div className="headingContainer">
                    Ratings
                    <span className="myntraweb-sprite index-productRatingsIcon sprites-productRatingsIcon"></span>
                </div>
                <div className="index-flexRow index-margin22 review-container">
                    <div className="index-flexColumn">
                        <div className="index-flexRow index-averageRating">
                            <span>{ratingMeta?.ratings_average}</span>
                            <span className="big-star"><img src={star} /></span>
                        </div>
                        <div className="index-countDesc">{ratingMeta?.total_ratings_count} Verified Buyers</div>
                    </div>
                    <div className="index-separator"></div>
                    <div className="progress-container progress-variant-1">
                        <div className="index-flexRow index-ratingBarContainer">
                            <div className="index-rating">
                                <span className="index-ratingLevel">Excellent</span>
                                {/* <span><img src={greyStar} /></span> */}
                            </div>
                            <div className="progress-wrapper" style={{ 
                                '--progress-percent': ratingMeta?.total_ratings_count > 0 
                                    ? `${(ratingMeta?.specific_rating_count?.[4] / ratingMeta?.total_ratings_count) * 100}%` 
                                    : '0%'
                            }}>
                                <progress
                                    min="0"
                                    max={ratingMeta?.total_ratings_count}
                                    value={ratingMeta?.specific_rating_count?.[4]}
                                    data-rating="5"
                                ></progress>
                                <span className="progress-star" data-rating="5">
                                    <img src={star} alt="star" />
                                </span>
                            </div>
                            <div className="index-count">{ratingMeta?.specific_rating_count?.[4] ?? 0}</div>
                        </div>
                        <div className="index-flexRow index-ratingBarContainer">
                            <div className="index-rating">
                                <span className="index-ratingLevel">Very Good</span>
                                {/* <span><img src={greyStar} /></span> */}
                            </div>
                            <div className="progress-wrapper" style={{ 
                                '--progress-percent': ratingMeta?.total_ratings_count > 0 
                                    ? `${(ratingMeta?.specific_rating_count?.[3] / ratingMeta?.total_ratings_count) * 100}%` 
                                    : '0%'
                            }}>
                                <progress
                                    min="0"
                                    max={ratingMeta?.total_ratings_count}
                                    value={ratingMeta?.specific_rating_count?.[3]}
                                    data-rating="4"
                                ></progress>
                                <span className="progress-star" data-rating="4">
                                    <img src={star} alt="star" />
                                </span>
                            </div>
                            <div className="index-count">{ratingMeta?.specific_rating_count?.[3] ?? 0}</div>
                        </div>
                        <div className="index-flexRow index-ratingBarContainer">
                            <div className="index-rating">
                                <span className="index-ratingLevel">Good</span>
                                {/* <span><img src={greyStar} /></span> */}
                            </div>
                            <div className="progress-wrapper" style={{ 
                                '--progress-percent': ratingMeta?.total_ratings_count > 0 
                                    ? `${(ratingMeta?.specific_rating_count?.[2] / ratingMeta?.total_ratings_count) * 100}%` 
                                    : '0%'
                            }}>
                                <progress
                                    min="0"
                                    max={ratingMeta?.total_ratings_count}
                                    value={ratingMeta?.specific_rating_count?.[2]}
                                    data-rating="3"
                                ></progress>
                                <span className="progress-star" data-rating="3">
                                    <img src={star} alt="star" />
                                </span>
                            </div>
                            <div className="index-count">{ratingMeta?.specific_rating_count?.[2] ?? 0}</div>
                        </div>
                        <div className="index-flexRow index-ratingBarContainer">
                            <div className="index-rating">
                                <span className="index-ratingLevel">Not Bad</span>
                                {/* <span><img src={greyStar} /></span> */}
                            </div>
                            <div className="progress-wrapper" style={{ 
                                '--progress-percent': ratingMeta?.total_ratings_count > 0 
                                    ? `${(ratingMeta?.specific_rating_count?.[1] / ratingMeta?.total_ratings_count) * 100}%` 
                                    : '0%'
                            }}>
                                <progress
                                    min="0"
                                    max={ratingMeta?.total_ratings_count}
                                    value={ratingMeta?.specific_rating_count?.[1]}
                                    data-rating="2"
                                ></progress>
                                <span className="progress-star" data-rating="2">
                                    <img src={star} alt="star" />
                                </span>
                            </div>
                            <div className="index-count">{ratingMeta?.specific_rating_count?.[1] ?? 0}</div>
                        </div>
                        <div className="index-flexRow index-ratingBarContainer">
                            <div className="index-rating">
                                <span className="index-ratingLevel">Bad</span>
                                {/* <span><img src={greyStar} /></span> */}
                            </div>
                            <div className="progress-wrapper" style={{ 
                                '--progress-percent': ratingMeta?.total_ratings_count > 0 
                                    ? `${(ratingMeta?.specific_rating_count?.[0] / ratingMeta?.total_ratings_count) * 100}%` 
                                    : '0%'
                            }}>
                                <progress
                                    min="0"
                                    max={ratingMeta?.total_ratings_count}
                                    value={ratingMeta?.specific_rating_count?.[0]}
                                    data-rating="1"
                                ></progress>
                                <span className="progress-star" data-rating="1">
                                    <img src={star} alt="star" />
                                </span>
                            </div>
                            <div className="index-count">{ratingMeta?.specific_rating_count?.[0] ?? 0}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="thumbnails-container">
                <div className="image-thumb-wrapper">
                    <div className="headline">
                        Customer Photos ({totalPhotos})
                    </div>
                    <div className="images-container images-container--limited">
                        {allPhotosFlat.length > 0 ? (
                            allPhotosFlat.slice(0, 14).map((url, i) => (
                                <div
                                    key={i}
                                    className={`image-container${i === 13 && totalPhotos > 14 ? ' image-container--has-more' : ''}`}
                                    onClick={() => openImageModal(allPhotosFlat, i)}
                                    role="button"
                                    tabIndex={0}
                                    onKeyDown={(e) => e.key === 'Enter' && openImageModal(allPhotosFlat, i)}
                                >
                                    <div className="image">
                                        <img src={url} alt={`Customer photo ${i + 1}`} />
                                        {i === 13 && totalPhotos > 14 && (
                                            <span className="more-images-count">+{totalPhotos - 14} more</span>
                                        )}
                                    </div>
                                </div>
                            ))
                        ) : (
                            <p className="reviews-empty-state">No customer photos yet</p>
                        )}
                    </div>
                </div>

                {imageModalOpen && modalCurrentUrl && (
                    <div className="web-reviews-image-modal" onClick={closeImageModal}>
                        <div className="web-reviews-image-modal__inner" onClick={(e) => e.stopPropagation()}>
                            <button
                                type="button"
                                className="web-reviews-image-modal__close"
                                onClick={closeImageModal}
                                aria-label="Close"
                            >
                                ×
                            </button>
                            <div className="web-reviews-image-modal__main">
                                <img src={modalCurrentUrl} alt="" />
                            </div>
                            <div className="web-reviews-image-modal__nav">
                                <button
                                    type="button"
                                    className="web-reviews-image-modal__prev"
                                    onClick={(e) => { e.stopPropagation(); if (canModalPrev) modalPrev(); }}
                                    disabled={!canModalPrev}
                                    aria-label="Previous image"
                                >
                                    <img src={leftArrowWhite} alt="" />
                                </button>
                                <button
                                    type="button"
                                    className="web-reviews-image-modal__next"
                                    onClick={(e) => { e.stopPropagation(); if (canModalNext) modalNext(); }}
                                    disabled={!canModalNext}
                                    aria-label="Next image"
                                >
                                    <img src={rightArrowWhite} alt="" />
                                </button>
                            </div>
                            <div className="web-reviews-image-modal__counter">
                                {modalCurrentIndex + 1} / {modalImagesList.length}
                            </div>
                            {modalImagesList.length > 1 && (() => {
                                const total = modalImagesList.length;
                                const maxThumbs = 6;
                                const start = total <= maxThumbs ? 0 : Math.max(0, Math.min(modalCurrentIndex - 1, total - maxThumbs));
                                const end = Math.min(start + maxThumbs, total);
                                const thumbIndices = Array.from({ length: end - start }, (_, idx) => start + idx);
                                return (
                                    <div className="web-reviews-image-modal__thumbs">
                                        {thumbIndices.map((idx) => (
                                            <button
                                                key={idx}
                                                type="button"
                                                className={`web-reviews-image-modal__thumb ${idx === modalCurrentIndex ? 'is-active' : ''}`}
                                                onClick={(e) => { e.stopPropagation(); setModalCurrentIndex(idx); }}
                                                aria-label={`Image ${idx + 1}`}
                                                aria-current={idx === modalCurrentIndex}
                                            >
                                                <img src={modalImagesList[idx]} alt="" />
                                            </button>
                                        ))}
                                    </div>
                                );
                            })()}
                        </div>
                    </div>
                )}

                {/* <div className="image-only-modal-container">
                    <div className="modal-container">
                        <header>
                            <span>X</span>
                            All Customers Photos
                        </header>

                        <div className="images-wrapper">
                            <div className="image">
                                <img src={img1} alt="img1" />
                            </div>
                            <div className="image">
                                <img src={img1} alt="img1" />
                            </div>
                            <div className="image">
                                <img src={img1} alt="img1" />
                            </div>
                            <div className="image">
                                <img src={img1} alt="img1" />
                            </div>
                            <div className="image">
                                <img src={img1} alt="img1" />
                            </div>
                            <div className="image">
                                <img src={img1} alt="img1" />
                            </div>
                            <div className="image">
                                <img src={img1} alt="img1" />
                            </div>
                            <div className="image">
                                <img src={img1} alt="img1" />
                            </div>
                        </div>

                    </div>
                </div> */}
                {
                    storedModelOpen &&
                    <div className="image-reviews-modal-container">
                        <div className="modal-container">

                            <div className="image-wrapper">
                                <span onClick={() => {
                                    setModelOpen(false);
                                    setStoredModelOpen(false);
                                }}>X</span>
                                <div className="image"><img src={storedModelOpen ? mainModelImageStored?.url : mainModelImage?.url} alt="img1" /></div>
                                <div className="button-container">
                                    <div className="prev" onClick={() => {
                                        if (modelOpen) {
                                            prev()
                                        }
                                        else if (storedModelOpen) {
                                            prevStored()
                                        }
                                    }}><img src={leftArrowWhite} /></div>
                                    <div className="next" onClick={() => {
                                        if (modelOpen) {
                                            next()
                                        }
                                        else if (storedModelOpen) {
                                            nextStored()
                                        }
                                    }}><img src={rightArrowWhite} /></div>
                                </div>
                                <div className="thumb-wrapper">
                                    <div className="thumb-container">
                                        <img src={ensureMediaUrl(storedModelOpen ? mainModelImageStored?.url : mainModelImage?.url)} alt="" />
                                    </div>
                                </div>
                            </div>

                            <div className="review-wrapper">
                                <div className="user-wrapper">
                                    <div className="user-review-main">

                                        <div className="startWrapper">
                                            <div>
                                                <div>5</div>
                                                <div><img src={whiteStar} /></div>
                                            </div>
                                        </div>

                                        <div className="reviewTextWrapper">
                                            Great fit and good cotton fabric, value for money.
                                        </div>
                                    </div>

                                    <div className="user-review-footer">
                                        <div className="user-review-left">
                                            <span>Avneesh Kumar Pal</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                }

                <div className="review-headline">
                    Customer Reviews ({ratingMeta?.reviews_data?.length || 0})
                </div>

                <div className="user-review-container">
                    {(ratingMeta?.reviews_data?.slice(0, 4) || []).map((ratings_data, reviewIndex) => {
                        const reviewPhotos = reviewImageUrls(ratings_data?.images);
                        return (
                                <div key={ratings_data?._id || reviewIndex} className="user-review-wrapper">
                                    <div className="main">
                                        <div
                                            className="review-rating-chip"
                                            data-rating={ratings_data?.rating ?? 5}
                                            role="img"
                                            aria-label={`${ratings_data?.rating ?? '–'} out of 5 stars`}
                                        >
                                            <span className="review-rating-chip__count">{ratings_data?.rating ?? '–'}</span>
                                            <span className="review-rating-chip__star" aria-hidden="true">★</span>
                                        </div>
                                        <div className="review-body">
                                            <div className="reviewTextRwapper">
                                                {ratings_data?.comment || '–'}
                                            </div>
                                            {reviewPhotos.length > 0 && (
                                            <div className="images-container">
                                                <div className="thumb-images">
                                                    {reviewPhotos.slice(0, 6).map((image, imageIndex) => (
                                                            <div key={imageIndex} className="images" onClick={() => openImageStored(reviewIndex, imageIndex, true)}>
                                                                <img src={image} alt={`Review photo ${imageIndex + 1}`} />
                                                            </div>
                                                        ))}
                                                </div>
                                            </div>
                                            )}
                                        </div>
                                    </div>

                                    <div className="footer">
                                        <div className="footer__reviewer">
                                            <span className="footer__text">
                                                {ratings_data?.user_type && String(ratings_data.user_type).toLowerCase() !== 'normal'
                                                    ? `Verified · ${ratings_data.user_type}`
                                                    : 'Verified customer'}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                        );
                    })}
                </div >
            </div >
            {ratingMeta?.reviews_data?.length > 0 && (
                <div className="review-links" onClick={() => navigate(`/full-review/${product_id}`)} role="button" tabIndex={0} onKeyDown={(e) => e.key === 'Enter' && navigate(`/full-review/${product_id}`)}>
                    View all {ratingMeta.reviews_data.length} reviews
                </div>
            )}
        </div >
    )
}